module.exports = __webpack_public_path__ + "static/img/fm.2ab8c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fm.jpg
// module id = cRBx
// module chunks = 14